import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { TrustpilotStarsComponent } from './trustpilot-stars/trustpilot-stars.component';
import { TrustpilotComponent } from './trustpilot/trustpilot.component';

@NgModule({
  exports: [TrustpilotComponent, TrustpilotStarsComponent],
  imports: [CommonModule, QueryParamModule, TrustpilotComponent, TrustpilotStarsComponent],
})
export class TrustpilotModule {}
